<template>
    <div>
        <template v-if="vendor === true">
            <div class="page-top mb-1 mb-3 clearfix">
                <h1 class="float-left"> Vendors </h1>
                <div v-if="crud_vendor">
                    <router-link to="/addVendorPersonalDetail" class="btn btn-primary float-right"> Add Vendor</router-link>
                    <router-link to="/vendorBulkUpload"  class="btn btn-primary float-right mr-1"> Vendor Bulk Upload </router-link>
                </div>
                <div class="searching float-right mr-2">
                    <input id="customSearch" type="text" class="form-control search" autocomplete="off" />
                </div>
            </div>
            <div class="page-top mb-1 mb-3 clearfix">
                <ul class="nav nav-tabs nav-tabs-1 float-left" id="myTab" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link active" id="active-vendors-tab" data-toggle="tab" href="#active-vendors" role="tab" aria-controls="active" aria-selected="true">Active ({{this.active_vendors_count}})</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="inactive-vendors-tab" data-toggle="tab" href="#inactive-vendors" role="tab" aria-controls="inactive" aria-selected="true">InActive ({{this.inactive_vendors_count}})</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="processing-vendors-tab" data-toggle="tab" href="#processing-vendors" role="tab" aria-controls="processing" aria-selected="false">Processing ({{this.processing_vendors_count}})</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="deleted-vendors-tab" data-toggle="tab" href="#deleted-vendors" role="tab" aria-controls="deleted" aria-selected="false">Deleted ({{this.deleted_vendors_count}})</a>
                    </li>
                </ul>
            </div>
            <div class="tab-content" id="myTabContent">
                <div class="tab-pane fade show active" id="active-vendors" role="tabpanel" aria-labelledby="active-vendors-tab">
                    <table id="dt-active-vendors" class="table" style="width:100%">
                        <thead>
                            <tr>
                                <th style="display: none;"></th>
                                <th>Name</th>
                                <th>Phone Number</th>
                                <th>Account Title</th>
                                <th>Beneficiary</th>
                                <th>Category</th>
                                <th>Profile</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="tab-pane fade show" id="inactive-vendors" role="tabpanel" aria-labelledby="inactive-vendors-tab">
                    <table id="dt-inactive-vendors" class="table" style="width:100%">
                        <thead>
                            <tr>
                                <th style="display: none;"></th>
                                <th>Name</th>
                                <th>Phone Number</th>
                                <th>Account Title</th>
                                <th>Beneficiary</th>
                                <th>Category</th>
                                <th>Profile</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="tab-pane fade show" id="processing-vendors" role="tabpanel" aria-labelledby="processing-vendors-tab">
                    <table id="dt-processing-vendors" class="table" style="width:100%">
                        <thead>
                            <tr>
                                <th style="display: none;"></th>
                                <th>Batch</th>
                                <th>Inserted</th>
                                <th>Updated</th>
                                <th>Discrepants</th>
                                <th>Status</th>
                                <th>Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="tab-pane fade show" id="deleted-vendors" role="tabpanel" aria-labelledby="deleted-vendors-tab">
                    <table id="dt-deleted-vendors" class="table" style="width:100%">
                        <thead>
                            <tr>
                                <th style="display: none;"></th>
                                <th>Name</th>
                                <th>Phone Number</th>
                                <th>Account Title</th>
                                <th>Beneficiary</th>
                                <th>Category</th>
                                <th>Profile</th>
                                <th>Action</th>
                                <th>Deleted At</th>
                            </tr>
                        </thead>
                    </table>
                </div>
            </div>
        </template>
        <template v-else-if="vendor === null">
            <preLoader></preLoader>
        </template>
        <template v-else-if="vendor === false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    var gthat = null;
    export default {
        data() {
            return {
                completeCount:null,
                data : null,
                vendor : null,
                crud_vendor : null,
                active_vendors_count : 0,
                inactive_vendors_count : 0,
                deleted_vendors_count : 0,
                processing_vendors_count : 0
            };
        },
        mounted() {
            gthat = this;
            this.$Progress.start();
            this.can('crud_vendor|vendor').then(result => {
                this.crud_vendor = result.crud_vendor;
                this.vendor = result.vendor;
            }).then(result => {
                if(this.vendor == true){
                    this.activeVendorsList();
                    this.inactiveVendorsList();
                    this.processingVendorsList();
                    this.deletedVendorsList();
                    this.$Progress.finish();
                }
            });
        },
        methods: {
            deleteVendor(id){
                swal.fire({
                    title: 'Are you sure?',
                    text: "You want to delete this vendor !",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!',
                    cancelButtonText: 'No, cancel!',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        axios.get('/api/deleteVendor/'+id)
                        .then(res => {
                            if(res.status == 200){

                                if(res.data == "Vendor cannot be deleted")
                                {
                                    gthat.showAlertBox('info','Vendor with the role of Maker, Checker, Approver Or Single Owner cannot be deleted.');
                                }
                                else if(res.data == "Vendor deleted successfully")
                                {
                                    $('#dt-active-vendors').DataTable().ajax.reload( json => {
                                        gthat.active_vendors_count = json.recordsTotal;
                                    }, false);

                                    $('#dt-inactive-vendors').DataTable().ajax.reload( json => {
                                        gthat.inactive_vendors_count = json.recordsTotal;
                                    }, false);

                                    $('#dt-deleted-vendors').DataTable().ajax.reload( json => {
                                        gthat.deleted_vendors_count = json.recordsTotal;
                                    }, false);

                                    gthat.showToastBox('success','Your vendor has been deleted');
                                }
                            }else{
                                gthat.showAlertBox('error','Error to delete vendor');
                            }
                        })
                        .catch(err => {
                            gthat.showAlertBox('error','Error to delete vendor');
                        });
                    } else if (result.dismiss === Swal.DismissReason.cancel){
                        swal.fire(
                            'Cancelled',
                            'Your decision has been cancelled',
                            'error'
                        )
                    }
                })
            },
            restoreVendor(id){
                swal.fire({
                    title: 'Are you sure?',
                    text: "You want to restore this vendor !",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, restore it!',
                    cancelButtonText: 'No, cancel!',
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) {
                        axios.get('/api/undoDeleteVendor/'+id)
                        .then(res => {
                            if(res.status == 200){
                                $('#dt-active-vendors').DataTable().ajax.reload( json => {
                                    gthat.active_vendors_count = json.recordsTotal;
                                }, false);

                                $('#dt-inactive-vendors').DataTable().ajax.reload( json => {
                                    gthat.inactive_vendors_count = json.recordsTotal;
                                }, false);

                                $('#dt-deleted-vendors').DataTable().ajax.reload( json => {
                                    gthat.deleted_vendors_count = json.recordsTotal;
                                }, false);

                                gthat.showToastBox('success','Your vendor has been restored');
                            }else{
                                gthat.showAlertBox('error','Error to restore vendor');
                            }
                        })
                        .catch(err => {
                            gthat.showAlertBox('error','Error to restore vendor');
                        });
                    } else if (result.dismiss === Swal.DismissReason.cancel){
                        swal.fire(
                            'Cancelled',
                            'Your decision has been cancelled',
                            'error'
                        )
                    }
                })
            },
            activeVendorsList(){
                var activeVendorsTable = $('#dt-active-vendors').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    ordering: false,
                    ajax: {
                        "url": "api/Vendors",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id', visible: false},
                        {data: 'name'},
                        {data: 'mobile_no'},
                        {render: function(data,type,full){
							if(full.default_beneficiary != null){
                                return full.default_beneficiary.account_title;
							}else{
								return "---";
							}
                        }},
                        {render: function(data,type,full){
							if(full.default_beneficiary != null){
                                return full.default_beneficiary.bank_name+'/'+full.default_beneficiary.account_number;
							}else{
								return "Beneficiary not set";
							}
                        }},
                        {render: function(data,type,full){
							if(full.category != null){
                                return full.category.name;
							}else{
								return "---";
							}
                        }},
                        {data: 'id',orderable:false, render: function(data,type,full){
                            if(full['wizard_cycle'] == 4){
                                return 'Complete';
                            }else{
                                return 'Incomplete';
                            }
                        }},
                        {data: 'id',orderable:false, render: function(data,type,full){
                            if(full['wizard_cycle'] == 0){
                                var $url = '/addVendorPersonalDetail/'+full['id'];
                            }else if(full['wizard_cycle'] == 1){
                                var $url = '/addVendorBasicDetail/'+full['id'];
                            }else if(full['wizard_cycle'] == 2){
                                var $url = '/addVendorTaxDetail/'+full['id'];
                            }else if(full['wizard_cycle'] == 3){
                                var $url = '/addVendorPaymentDetail/'+full['id'];
                            }else if(full['wizard_cycle'] == 4){
                                var $url = '/editVendor/'+full['id'];
                            }
                            if(full['delete_able'] == true && gthat.crud_vendor){
                                return '<td class="text-center"> <a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="Edit" class="action edit"> <i class="fas fa-pencil-alt"></i> </a> <a href="javascript:void(0);" onclick="VueComponents.vendorsComponent.methods.deleteVendor('+full.id+')" data-toggle="tooltip" data-placement="top" title="Delete" class="action delete"> <i class="fas fa-trash-alt"></i> </a> </td>';
                            }else{
                                return '<td class="text-center"> <a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="Edit" class="action edit"> <i class="fas fa-pencil-alt"></i> </a> </td>';
                            }
                        }}
                    ],
                    "order": [[ 0, "desc" ]],
                    "initComplete": (settings, json) => {
                        this.$Progress.finish();
                        this.active_vendors_count = json.recordsTotal;
                    }
                });
                $('#customSearch').on( 'keyup', function () {
                    activeVendorsTable.search(this.value).draw();
                });
            },
            inactiveVendorsList(){
                var inactiveVendorsTable = $('#dt-inactive-vendors').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    ajax: {
                        "url": "api/inactiveVendors",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id', visible: false},
                        {data: 'name'},
                        {data: 'mobile_no'},
                        {render: function(data,type,full){
							if(full.default_beneficiary != null){
                                return full.default_beneficiary.account_title;
							}else{
								return "---";
							}
                        }},
                        {render: function(data,type,full){
							if(full.default_beneficiary != null){
                                return full.default_beneficiary.bank_name+'/'+full.default_beneficiary.account_number;
							}else{
								return "Beneficiary not set";
							}
                        }},
                        {render: function(data,type,full){
							if(full.category != null){
                                return full.category.name;
							}else{
								return "---";
							}
                        }},
                        {data: 'id',orderable:false, render: function(data,type,full){
                            if(full['wizard_cycle'] == 4){
                                return 'Complete';
                            }else{
                                return 'Incomplete';
                            }
                        }},
                        {data: 'id',orderable:false, render: function(data,type,full){
                            if(full['wizard_cycle'] == 0){
                                var $url = '/addVendorPersonalDetail/'+full['id'];
                            }else if(full['wizard_cycle'] == 1){
                                var $url = '/addVendorBasicDetail/'+full['id'];
                            }else if(full['wizard_cycle'] == 2){
                                var $url = '/addVendorTaxDetail/'+full['id'];
                            }else if(full['wizard_cycle'] == 3){
                                var $url = '/addVendorPaymentDetail/'+full['id'];
                            }else if(full['wizard_cycle'] == 4){
                                var $url = '/editVendor/'+full['id'];
                            }
                            if(full['delete_able'] == true && gthat.crud_vendor){
                                return '<td class="text-center"> <a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="Edit" class="action edit"> <i class="fas fa-pencil-alt"></i> </a> <a href="javascript:void(0);" onclick="VueComponents.vendorsComponent.methods.deleteVendor('+full.id+')" data-toggle="tooltip" data-placement="top" title="Delete" class="action delete"> <i class="fas fa-trash-alt"></i> </a> </td>';
                            }else{
                                return '<td class="text-center"> <a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="Edit" class="action edit"> <i class="fas fa-pencil-alt"></i> </a> </td>';
                            }
                        }}
                    ],
                    "order": [[ 0, "desc" ]],
                    "initComplete": (settings, json) => {
                        this.$Progress.finish();
                        this.inactive_vendors_count = json.recordsTotal;
                    }
                });
                $('#customSearch').on( 'keyup', function () {
                    inactiveVendorsTable.search(this.value).draw();
                });
            },
            processingVendorsList(){
                var processingVendorsTable = $('#dt-processing-vendors').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    ajax: {
                        "url": "api/processingVendors",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id', visible: false},
                        {data: 'file_name'},
                        {data: 'inserted'},
                        {data: 'updated'},
                        {data: 'discrepants'},
                        {data: 'status'},
                        {data: 'batch_date'},
                        {data: 'id', sorting: false, render: function(data,type,full){
                            if(full.discrepants > 0){
                                return '<td class="text-center"> <a href="javascript:void(0);" onclick="downloadVendorDiscrepants('+data+')" data-toggle="tooltip" data-placement="top" title="Download & Delete"><i class="far fa-file-excel" aria-hidden="true"></i> Discrepants</a></td>';
                            }else{
                                return '<td class="text-center"></td>';
                            }
                        }}
                        
                    ],
                    "order": [[ 0, "desc" ]],
                    // "columnDefs": [ 
                    //     { "orderable": false, "targets": [2,4,5,7] }
                    // ],
                    "initComplete": (settings, json) => {
                        this.$Progress.finish();
                        gthat.processing_vendors_count = json.precessingTotal;
                    }
                });
                window.processingVendorsTable = processingVendorsTable;
            },
            deletedVendorsList(){
                var deletedVendorsTable = $('#dt-deleted-vendors').DataTable({
                    "sDom": '<"table-holder mb-3"t><"row view-pager"<"col-sm-4 text-left"i"><"col-sm-4 text-center"p"><"col-sm-4 text-right"l>>r',
                    processing: true,
                    serverSide: true,
                    ajax: {
                        "url": "api/deletedVendors",
                        "headers": window.axios.defaults.headers.common,
                        "dataSrc": "records",
                    },
                    deferRender: true,
                    columns: [
                        {data: 'id', visible: false},
                        {data: 'name'},
                        {data: 'mobile_no'},
                        {render: function(data,type,full){
							if(full.default_beneficiary != null){
                                return full.default_beneficiary.account_title;
							}else{
								return "---";
							}
                        }},
                        {render: function(data,type,full){
							if(full.default_beneficiary != null){
                                return full.default_beneficiary.bank_name+'/'+full.default_beneficiary.account_number;
							}else{
								return "Beneficiary not set";
							}
                        }},
                        {render: function(data,type,full){
							if(full.category != null){
                                return full.category.name;
							}else{
								return "---";
							}
                        }},
                        {data: 'id',orderable:false, render: function(data,type,full){
                            if(full['wizard_cycle'] == 4){
                                return 'Complete';
                            }else{
                                return 'Incomplete';
                            }
                        }},
                        {data: 'id',orderable:false, render: function(data,type,full){
                            if(full['wizard_cycle'] == 0){
                                var $url = '/addVendorPersonalDetail/'+full['id'];
                            }else if(full['wizard_cycle'] == 1){
                                var $url = '/addVendorBasicDetail/'+full['id'];
                            }else if(full['wizard_cycle'] == 2){
                                var $url = '/addVendorTaxDetail/'+full['id'];
                            }else if(full['wizard_cycle'] == 3){
                                var $url = '/addVendorPaymentDetail/'+full['id'];
                            }else if(full['wizard_cycle'] == 4){
                                var $url = '/editVendor/'+full['id'];
                            }
                            if(gthat.crud_vendor){
                                return '<td class="text-center"> <a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="Edit" class="action edit"> <i class="fas fa-pencil-alt"></i> </a> <a href="javascript:void(0);" onclick="VueComponents.vendorsComponent.methods.restoreVendor('+full.id+')" data-toggle="tooltip" data-placement="top" title="Restore" class="action restore"> <i class="fas fa-undo"></i> </a> </td>';
                            }else{
                                return '<td class="text-center"> <a href="javascript:void(0);" onclick="window.vueRouterPush(\''+$url+'\')" data-toggle="tooltip" data-placement="top" title="Edit" class="action edit"> <i class="fas fa-pencil-alt"></i> </a> </td>';
                            }
                        }},
                        {data: 'deleted_at', orderable:false, render: function(data, type, full){
                            if(full['deleted_at'] == null || full['deleted_at'] == '0000-00-00 00:00:00'){
                                return '-';
                            }else{
                                return  '' + moment(full['deleted_at']).format('MMM D, Y') + '';
                            }
                        }}
                    ],
                    "order": [[ 0, "desc" ]],
                    "initComplete": (settings, json) => {
                        this.$Progress.finish();
                        this.deleted_vendors_count = json.recordsTotal;
                    }
                });
                $('#customSearch').on( 'keyup', function () {
                    deletedVendorsTable.search(this.value).draw();
                });
            }
        }
    }
</script>
